import React from 'react'
import { NavLink, useParams } from 'react-router-dom'

import css from './MenuItem.module.scss'

const ConditionalLink = ({ item, children, orgId }) => {
  return item.onClick ? (
    <button onClick={item.onClick} className={css.NavLink} type='button'>
      {children}
    </button>
  ) : (
    <NavLink
      to={`/${item.subPath ? orgId : ''}${item.path}`}
      className={({ isActive }) => (isActive ? css.NavActive : css.NavLink)}
    >
      {children}
    </NavLink>
  )
}

const MenuItem = ({ item }) => {
  const { orgId } = useParams()

  return (
    <ConditionalLink item={item} orgId={orgId}>
      <i className={item.icon} />
      {item.label}
    </ConditionalLink>
  )
}

export default MenuItem
